import { useCallback } from 'react';
import useOpenDrawerSettings from './useOpenDrawerSettings';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { useEnableSplitTest } from '../../../../state/SplitTests/actions/useEnableSplitTest';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { useDisplayWebContent } from './useDisplayWebContent';
import { WebsiteContentMessage } from 'sections/onsite-campaigns/types';
import { CampaignMessage } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorState';
import { uuid } from 'utils';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useConvertMessageToSplitTest = ({ id }: { id: string }) => {
  const { openDrawerSettings } = useOpenDrawerSettings();
  const { state, dispatch } = useWorkFlowCanvas();

  const { getDisplayWebContent, addDisplayWebContent, setControlGroupMessages } = useDisplayWebContent();
  const enableSplitTest = useEnableSplitTest();
  const { dispatch: editorDispatch } = useCampaignEditorContext();

  const displayWebContent: CampaignMessage<WebsiteContentMessage> = getDisplayWebContent(id);

  return useCallback(() => {
    const variantId = id;
    const segmentId = displayWebContent?.segmentId;

    const { nodes, edges } = Canvas.createFromState(state)
      .enableSplitTest(variantId, segmentId)
      .convertToState();

    dispatch({
      type: 'UPDATE',
      payload: { nodes, edges },
    });

    if (Object.keys(displayWebContent?.scheduling ?? {})) {
      editorDispatch({
        type: 'REMOVE_SEGMENT_DATETIMES',
        payload: {
          id,
        },
      });
    }

    const secondVariantId = uuid();
    enableSplitTest({ id: segmentId, firstVariantId: variantId, secondVariantId: secondVariantId });
    addDisplayWebContent(secondVariantId, segmentId);

    openDrawerSettings(segmentId, 'split-test-settings');
    setControlGroupMessages(id, false, undefined);
  }, [
    addDisplayWebContent,
    dispatch,
    editorDispatch,
    displayWebContent?.segmentId,
    displayWebContent?.scheduling,
    enableSplitTest,
    setControlGroupMessages,
    id,
    openDrawerSettings,
    state,
  ]);
};
